<template>
  <div style="user-select: none;" class="col-3 sm-col-6 flex justify-center mb3 px2">
    <div class="card white-bg col-12 border-bottom center relative">
      <div class="flex items-center col-12">
        <!-- <i v-if="missingDocuments" class="h3 ml1 mt1 red icon icon-attention"></i> -->
        <div class="flex-auto"></div>
        <i class="h3 mr1 mt1 justify-end icon pointer icon-not-check-icon" @click="removeParticipant()"></i>
      </div>
      <div class="col-12 center">
        <i class="icon mx-auto line-height-1 relative h1 i-user mt2"></i>
        <p class="my0">{{ participant.firstname }} {{ participant.lastname }}</p>
      </div>
      <div class="absolute bottom-0 left-0 right-0 mt1">
        <div class="lighter-grey-bg mt2 mb1">
          <p class="py1 my0 h6 caps bold">{{ participant.tariff.label }}</p>
        </div>
        <div v-if="showQuantityChanger" class="mb1">
          <i style="top: 2px" class="icon icon-minus pointer" @click="handleQuantity(-1)"></i>
          <span class="mx1">{{ participant.quantity }}</span>
          <i style="top: 2px" class="icon icon-add-more-icon pointer" @click="handleQuantity(1)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { participant: Object },
  data () {
    return {
      participants: this.$store.state.cartItem.participants,
      offerInfo: this.$store.state.offerInfo,
      siteInfo: this.$store.state.siteInfo
    };
  },
  computed: {
    showQuantityChanger () {
      const disabled_features = this?.siteInfo?.tda_settings?.disabled_features || [];

      return !(this.offerInfo.detail.recurring
      || this.offerInfo.detail.reservation
      || this.offerInfo.detail.inscription
      || disabled_features.includes('participant-quantity-changer'));

      // return !this.offerInfo.detail.recurring
      // && !this.offerInfo.detail.reservation
      // && !this.offerInfo.detail.inscription
      // && (!disabled_features.includes('participantQuantityChanger'));
    },
    missingDocuments () {
      const docs = this.participant.tariff?.documents;
      if (!docs) {
        return false;
      }
      return !docs.validInfo;
    }
  },
  methods: {
    handleQuantity (quantity) {
      const quantityUpdated = this.participant.quantity + (quantity);
      if (quantityUpdated > 0) {
        const participantIndex = this.participants.findIndex(p => p.uuid === this.participant.uuid);
        if (participantIndex !== -1) {
          this.participants[participantIndex].quantity = quantityUpdated;
          this.$store.commit('manageCartItemParticipant', { index: participantIndex, participant: this.participants[participantIndex] });
        }
      }
    },
    removeParticipant () {
      const participantIndex = this.participants.findIndex(p => p.uuid === this.participant.uuid);
      if (participantIndex !== -1) {
        this.$store.commit('manageCartItemParticipant', { index: participantIndex });
      }
    }
  }
};
</script>
